var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{on:{"click":_vm.onClickCopy}},[_c('IconV2',{staticClass:"pointer",staticStyle:{"z-index":"999"},attrs:{"name":"v2-copy","color":_vm.color}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }